import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TelPhoneIcon } from '../common/icon';
import { Drawer, Popover } from 'aha-components';
import DownloadAppQrImage from './DownloadAppQrImage';

export default function DownloadAppTextButton({
  compact = false
}: {
  compact?: boolean;
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <Popover
        open={open}
        onOpenChange={setOpen}
        content={
          <div className="flex flex-col gap-[10px] w-[207px] p-1">
            <DownloadAppQrImage />
            <div className="justify-start text-[#79716B] text-sm font-medium font-['DM_Sans'] leading-5">
              {t('downloadAppTextButton.downloadStoresHint', {
                defaultValue: 'Download iOS / Android app'
              })}
            </div>
          </div>
        }
        placement="right"
        trigger="click"
        className="!hidden md:!block"
      >
        {compact ? (
          <button
            type="button"
            aria-label={t('downloadAppTextButton.getOnMobile', {
              defaultValue: 'Get AhaCreator on mobile'
            })}
            className="flex h-9 w-9 items-center justify-center rounded-xl border-0 bg-[var(--creator-sidebar-surface)]"
          >
            <TelPhoneIcon />
          </button>
        ) : (
          <button
            type="button"
            className="mt-3 flex h-9 w-full items-center gap-2 overflow-hidden rounded-md border-0 bg-[var(--creator-sidebar-surface)] p-2 text-left md:mt-0"
          >
            <TelPhoneIcon className="shrink-0" />
            <span className="creator-sidebar-mobile-label min-w-0 whitespace-nowrap font-['Inter'] text-sm font-semibold leading-5 text-[var(--creator-sidebar-text)]">
              {t('downloadAppTextButton.getOnMobile', {
                defaultValue: 'Get AhaCreator on mobile'
              })}
            </span>
          </button>
        )}
      </Popover>
      <div className="md:hidden">
        <button
          type="button"
          className="mt-3 flex w-full items-center gap-2 rounded-sm border-0 bg-[#FAFAF9] p-2 text-left"
          onClick={() => setIsDrawerOpen(true)}
        >
          <TelPhoneIcon />
          <div className="justify-start text-[#44403C] text-sm font-semibold font-['DM_Sans'] leading-5">
            {t('downloadAppTextButton.getOnMobile', {
              defaultValue: 'Get AhaCreator on mobile'
            })}
          </div>
        </button>
        <Drawer
          open={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          zIndex={1400}
          height="auto"
          placement="bottom"
          closable={false}
          drawerStyle={{
            borderRadius: '16px 16px 0 0',
            maxHeight: 'calc(100dvh - 16px)',
            overflow: 'hidden'
          }}
          bodyStyle={{
            padding: 0,
            flex: 'none',
            maxHeight: 'calc(100dvh - 16px)',
            overflowY: 'auto'
          }}
        >
          <div className="flex flex-col gap-[18px] py-[18px] items-center justify-center">
            <DownloadAppQrImage widthClassName="w-[195px]" />
            <div className="justify-start text-[#79716B] text-sm font-medium font-['DM_Sans'] leading-5">
              {t('downloadAppTextButton.downloadStoresHint', {
                defaultValue: 'Download iOS / Android app'
              })}
            </div>
          </div>
        </Drawer>
      </div>
    </>
  );
}
